import AxiosConfig from '../../../config/AxiosConfig';

const useConfirmSavDraft = () => {
  const confirmSavDraft = async (id, data) => {
    try {
      const response = await AxiosConfig.create(
        'put',
        `/savdraft/${id}/confirm`
      )
        .call(data)
        .getResponseData();

      return response;
    } catch (err) {
      // Ne jamais logger `err` en entier : une AxiosError porte `config.data`,
      // c'est-à-dire le corps de la requête envoyée (nom, téléphone, adresses
      // du client dans `formData`). On ne journalise que le strict minimum
      // technique (statut HTTP / message d'erreur), jamais la charge utile.
      console.error(
        'Failed to confirm SAV draft:',
        err?.response?.status ?? err?.message
      );

      // Le backend (`PUT /savdraft/:id/confirm`) répond avec un vrai statut
      // HTTP non-2xx sur un refus métier (ex: rupture de stock), corps
      // `{ error: "<motif>" }`. Axios jette sur ces statuts : on remonte ce
      // motif dans la forme que buildSavOrderMessages consomme déjà
      // (`errorInfos.status`/`errorInfos.message`) au lieu de le perdre dans
      // une Error générique.
      if (err?.response) {
        return {
          errorInfos: {
            status: err.response.status,
            message: err.response.data?.error,
          },
        };
      }

      // Pas de réponse HTTP (réseau coupé, timeout...) : aucun motif métier
      // à remonter, l'appelant gère l'échec générique.
      throw new Error(`confirmSavDraft failed: ${err?.message}`);
    }
  };

  return {
    confirmSavDraft,
  };
};

export default useConfirmSavDraft;
